import {useTranslation} from "react-i18next";
import React from "react";

const InfoItem = ({name, value, isLoading}) => {
    const {t} = useTranslation()

    return (
        <div className="bazaar_current-item_modal-info-item">
            <span>{t(name)}</span>
            <span {...(isLoading && {className: "skeleton"})}>{value}</span>
        </div>
    )
}

export default InfoItem